var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSponserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.582,
    height: 24,
    viewBox: "0 0 20.582 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Orphan_Sponsorship_Report",
    "data-name": "Orphan Sponsorship Report",
    transform: "translate(-38 -0.1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_170_",
    d: "M345.511,70.051h2.438L345,67.2v2.405A.5.5,0,0,0,345.511,70.051Z",
    transform: "translate(-292.607 -63.954)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_174_",
    d: "M91.029,46.1a2.357,2.357,0,0,1-2.386-2.325V40.128L78.488,40.1a.493.493,0,0,0-.488.469V59.876a.524.524,0,0,0,.511.478H94.4a.452.452,0,0,0,.427-.478V46.1Zm-1.683,3.7a.938.938,0,0,1,0,1.875h-8.2a.938.938,0,0,1,0-1.875ZM81.094,46.05h5.439a.938.938,0,0,1,0,1.875H81.094a.938.938,0,0,1,0-1.875Zm10.6,9.377H81.141a.938.938,0,0,1,0-1.875H91.69a.938.938,0,0,1,0,1.875Z",
    transform: "translate(-38.125 -38.125)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_488_",
    d: "M58.123,6.181,52.417.658a1.884,1.884,0,0,0-1.308-.53L40.363.1A2.355,2.355,0,0,0,38,2.444V21.751A2.4,2.4,0,0,0,40.386,24.1H56.28a2.329,2.329,0,0,0,2.3-2.354V7.3A1.542,1.542,0,0,0,58.123,6.181ZM52.393,3.246,55.342,6.1H52.9a.5.5,0,0,1-.511-.45ZM56.28,22.225H40.386a.52.52,0,0,1-.511-.478V2.444a.493.493,0,0,1,.488-.469L50.518,2V5.646A2.36,2.36,0,0,0,52.9,7.972h3.8V21.746A.452.452,0,0,1,56.28,22.225Z",
    transform: "translate(0 0)",
    fill: "#444"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Orphan_Donation_History",
    "data-name": "Orphan Donation History",
    transform: "translate(39.5 2.4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10191",
    "data-name": "Path 10191",
    d: "M14.179,10.789a.551.551,0,0,0-.438.311A5.237,5.237,0,0,0,8.687,6.7a5.237,5.237,0,0,0-5.053,4.4.551.551,0,0,0-.438-.311c-.387,0-.7.621-.7,1.4s.309,1.4.7,1.4a.551.551,0,0,0,.438-.311A5.236,5.236,0,0,0,8.687,17.7a5.236,5.236,0,0,0,5.053-4.426.516.516,0,0,0,.438.311c.387,0,.7-.621.7-1.4S14.566,10.789,14.179,10.789Z",
    transform: "translate(0)",
    fill: "none",
    stroke: "#444",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10192",
    "data-name": "Path 10192",
    d: "M22.512,6.7A3.006,3.006,0,0,1,23.62,8.641v.129A1.111,1.111,0,0,1,22.46,9.78a1.083,1.083,0,0,1-1.005-1.009.942.942,0,0,1,.309-.725M21.3,14.1a3.291,3.291,0,0,0,2.707,0",
    transform: "translate(-13.953 0.458)",
    fill: "none",
    stroke: "#444",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2",
    "data-name": "Line 2",
    x2: 0.361,
    transform: "translate(10.26 11.747)",
    fill: "none",
    stroke: "#444",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3",
    "data-name": "Line 3",
    x2: 0.387,
    transform: "translate(6.754 11.747)",
    fill: "none",
    stroke: "#444",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10194",
    "data-name": "Path 10194",
    d: "M32.6,7.6a2.116,2.116,0,0,1,.516,2.174",
    transform: "translate(-22.34 -0.667)",
    fill: "none",
    stroke: "#444",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSponserIcon);
export default __webpack_public_path__ + "static/media/sponserIcon.87668510384e101ebab578472a68f82d.svg";
export { ForwardRef as ReactComponent };